/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect } from 'react';
import { Storage } from 'aws-amplify';
// import { useTranslation } from 'react-i18next';
// import Input from 'shared/components/Input';

import SkeletonLoader from 'shared/components/ui/SkeletonLoader';
import { useDispatch, useSelector } from 'react-redux';
import { onSetProjectsImages } from 'app/routes/Dashboard/actions/projects';
import { getError } from 'utils/appHelpers';
import { useAlert } from 'react-alert';

const ProjectImageSelection = ({ image, setImage }) => {
  const alert = useAlert();
  const projectImages = useSelector(state => state.projectImages) || [];
  const dispatch = useDispatch();
  // const { t } = useTranslation();
  // const [search, setSearch] = useState('');

  // const onSearchChange = ({ target }) => {
  //   setSearch(target.value);
  // };

  const getImages = async () => {
    try {
      const images = await Storage.list('FolderIcons', { level: 'public' });
      const data = images.results.map(async item => {
        if (!item.size) return false;
        const img = await Storage.get(item.key, { level: 'public' });
        const { origin, pathname } = new URL(img);
        item.image = `${origin}${pathname}`;
        return item;
      });
      dispatch(onSetProjectsImages(await Promise.all(data)));
    } catch (err) {
      alert.error(getError(err));
    }
  };

  useEffect(() => {
    getImages();
  }, []);

  if (!projectImages?.length) return <SkeletonLoader type='categories' count={6} className='my-5' />;

  // const currentImages = [...projectImages].filter(i => i.category.includes(search));
  const currentImages = [...projectImages];

  return (
    <div className='pb-10'>
      {/* <div className='mb-15'>
        <Input
          type='text'
          className='mb-0'
          name='search'
          value={search}
          placeholder={t('ph_image')}
          onChange={onSearchChange}
        />
      </div> */}
      <div className='scroll-y-content max-h-250 d-flex flex-wrap project-image-selection justify-content-md-around justify-content-between'>
        {currentImages.map((item, i) => {
          if (!item.image || !item.size) return null;
          const isActive = image === item.image;
          return (
            <div className='px-2 mb-5' key={i}>
              <div>
                <img
                  onClick={() => setImage(item.image)}
                  width={92}
                  height={92}
                  className={`rounded-5 cursor-pointer ${isActive ? 'active' : ''}`}
                  src={item.image}
                  alt=''
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProjectImageSelection;
